import { createSlice } from "@reduxjs/toolkit";
import syncedStorage from "../services/syncedStorage";
import { COMPANY_KEY } from "../constants/localKeys";
import secureLogger from '../utils/secureLogger';
import { validateGSTIN } from '../utils/gstValidators';

const initialState = {
  data: {
    id: "companyID",
    image: "",
    billingAddress: "",
    companyName: "",
    companyEmail: "",
    companyMobile: "",
    companyGST: "",
    companyUDYAM: "",
    companySAC: "",
    bankName: "",
    accountName: "",
    accountNumber: "",
    branchName: "",
    ifscCode: "",
    sealImage: "",
  },
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    updateCompanyData: (state, action) => {
      try {
        const {
          image,
          billingAddress,
          companyName,
          companyEmail,
          companyMobile,
          companyGST,
          companyUDYAM,
          companySAC,
          bankName,
          accountName,
          accountNumber,
          branchName,
          ifscCode,
          sealImage
        } = action.payload;

        // Validate company GSTIN if provided
        if (companyGST && companyGST.trim()) {
          const gstValidation = validateGSTIN(companyGST);
          if (!gstValidation.valid) {
            secureLogger.error('Invalid company GSTIN:', gstValidation.error);
            // Still allow saving but log the error for user awareness
          } else {
            secureLogger.info('Company GSTIN validated successfully');
          }
        }

        state.data.image = image ? image : "";
        state.data.billingAddress = billingAddress ? billingAddress : "";
        state.data.companyName = companyName ? companyName : "";
        state.data.companyEmail = companyEmail ? companyEmail : "";
        state.data.companyMobile = companyMobile ? companyMobile : "";
        state.data.companyGST = companyGST ? companyGST : "";
        state.data.companyUDYAM = companyUDYAM ? companyUDYAM : "";
        state.data.companySAC = companySAC ? companySAC : "";
        state.data.bankName = bankName ? bankName : "";
        state.data.accountName = accountName ? accountName : "";
        state.data.accountNumber = accountNumber ? accountNumber : "";
        state.data.branchName = branchName ? branchName : "";
        state.data.ifscCode = ifscCode ? ifscCode : "";
        state.data.sealImage = sealImage ? sealImage : "";
        try {
          syncedStorage.setItem(COMPANY_KEY, action.payload);
        } catch (e) {
          secureLogger.error('Error saving company data:', e);
        }
      } catch (e) {
        secureLogger.error('Error updating company data:', e);
      }
    },
  },
});

export const { updateCompanyData } = companySlice.actions;

export const getCompanyData = (state) => state.company.data;

export default companySlice.reducer;
